module.exports = __webpack_public_path__ + "img/zula-338x160.c8bdc6d0.png";